import { render, staticRenderFns } from "./PaymentCallback.vue?vue&type=template&id=77799142&scoped=true&"
import script from "./PaymentCallback.vue?vue&type=script&lang=js&"
export * from "./PaymentCallback.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCallback.vue?vue&type=style&index=0&id=77799142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77799142",
  null
  
)

export default component.exports